import React, { MouseEvent } from 'react'
import styled, { css } from 'styled-components/macro'

type buttonTheme = 'defaultBlue'

export type Props = {
  text?: string | number
  buttonTheme?: buttonTheme
  onClick?: (e: MouseEvent) => void
  style?: React.CSSProperties
  id?: string
  link?: string
}

export default function Button({ text, buttonTheme = 'defaultBlue', onClick, link, ...props }: Props) {
  const formattedLink = link && !/^(http|https):\/\//i.test(link) ? `http://${link}` : link

  return formattedLink ? (
    <ButtonComponent buttonTheme={buttonTheme} onClick={onClick} {...props} target="_blank" href={`${formattedLink}`}>
      {text}
    </ButtonComponent>
  ) : (
    <ButtonComponent buttonTheme={buttonTheme} onClick={onClick} {...props}>
      {text}
    </ButtonComponent>
  )
}
const buttonThemeCss = (theme: buttonTheme) => {
  if (theme === 'defaultBlue')
    return css`
      color: #0097fe;
      font-family: roboto;
      cursor: pointer;
      font-weight: 400;
      &:hover {
        color: #003893;
      }
    `
  return css``
}

const ButtonComponent = styled.a<{ buttonTheme: buttonTheme }>`
  ${(props) => buttonThemeCss(props.buttonTheme)}
`
